<template>
	<div class='notification-wrapper'>
		<div class='notification-wrapper__author'>
			<div class='profile'>
				<a class='image-wrapper' v-if='notification.user.photo_small' :href='`/profile/${notification.user.id}/`'>
					<img :src='notification.user.photo_small' >
				</a>
				<div class='info'>
					<ClosedDealText v-if='notification.type==="deal_closed"' :notification='notification' />
					<AdditionsToRolodexText v-if='notification.type==="new_contact"' :notification='notification' :contactTypes='contactTypes' />
					<NewCertifiedAgentsText v-if='notification.type==="new_agent"' :notification='notification' />
					<NewMembersText v-if='notification.type==="new_member"' :notification='notification' />
					<NewPublicDealsText v-if='notification.type==="new_public_deal"' :notification='notification' />
					<OfferAcceptedText v-if='notification.type==="deal_offer_accepted"' :notification='notification' />
					<div class='date'>
						{{notification.created_at|formatDate}}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import global from '__jsVueMixin/global';
import ClosedDealText from './ClosedDealText/ClosedDealText.vue';
import AdditionsToRolodexText from './AdditionsToRolodexText/AdditionsToRolodexText.vue';
import NewCertifiedAgentsText from './NewCertifiedAgentsText/NewCertifiedAgentsText.vue';
import NewMembersText from './NewMembersText/NewMembersText.vue';
import NewPublicDealsText from './NewPublicDealsText/NewPublicDealsText.vue';
import OfferAcceptedText from './OfferAcceptedText/OfferAcceptedText.vue';
export default {
	name:       'Notification',
	mixins:     [global],
	components: {
		ClosedDealText,
		AdditionsToRolodexText,
		NewCertifiedAgentsText,
		NewMembersText,
		NewPublicDealsText,
		OfferAcceptedText,
	},
	props: {
		notification: {
			type: Object
		},
		contactTypes: {
			type: Object
		}
	}
};
</script>
